import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useWebsite } from '../../contexts/WebsiteContext';

/**
 * `/dashboard/websites/:id/stats` used to render its own analytics screen. That
 * screen served invented numbers, so it is gone — this hands the request to the
 * real Analytics page instead, with the requested site pre-selected.
 */
const WebsiteStatsRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { setSelectedWebsiteId } = useWebsite();

  useEffect(() => {
    if (id) setSelectedWebsiteId(id);
  }, [id, setSelectedWebsiteId]);

  return <Navigate to="/dashboard/analytics" replace />;
};

export default WebsiteStatsRedirect;
